export const environment = {
    NODE_ENV: process.env.NODE_ENV,
    APP_MEDIA_CDN_URL: process.env.NEXT_PUBLIC_APP_MEDIA_CDN_URL,
    BACKEND_URL: process.env.NEXT_PUBLIC_BACKEND_URL,
    QMS_BASE_URL: process.env.QMS_BASE_URL,
    CMS_IDENTIFIER: process.env.CMS_IDENTIFIER,
    CMS_IDENTIFIER_PASSWORD: process.env.CMS_IDENTIFIER_PASSWORD,
    CMS_CACHE_TTL: process.env.CMS_CACHE_TTL,
    CMS_MEDIA_CDN_URL: process.env.NEXT_PUBLIC_CMS_MEDIA_CDN_URL,
    CMS_URL: process.env.CMS_URL,
    CONSOLE_TRACKER_ENABLED: process.env.NEXT_PUBLIC_CONSOLE_TRACKER_ENABLED,
    DISABLE_BASIC_AUTH: process.env.DISABLE_BASIC_AUTH,
    EXTERNAL_MEDIA_CDN_URL: process.env.NEXT_PUBLIC_EXTERNAL_MEDIA_CDN_URL,
    GTM_ID: process.env.NEXT_PUBLIC_GTM_ID,
    PO_EDITOR_PROJECT_ID: process.env.PO_EDITOR_PROJECT_ID,
    REDIS_URL: process.env.REDIS_URL,
    SENTRY_DSN: process.env.SENTRY_DSN,
    SMARTTRADE_MEDIA_CDN_URL: process.env.NEXT_PUBLIC_SMARTTRADE_MEDIA_CDN_URL,
    WEBSITE_BACKEND_AUTH_TOKEN: process.env.WEBSITE_BACKEND_AUTH_TOKEN,
    QMS_CACHE_TTL: process.env.QMS_CACHE_TTL,
    DEFAULT_TTL: process.env.DEFAULT_TTL,
    APP_MEDIA_S3_URL: process.env.APP_MEDIA_S3_URL,
    SMART_TRADE_MEDIA_S3_URL: process.env.SMART_TRADE_MEDIA_S3_URL,
    EXTERNAL_MEDIA_S3_URL: process.env.EXTERNAL_MEDIA_S3_URL,
    ONE_TRUST_SCRIPT_ID: process.env.ONE_TRUST_SCRIPT_ID,
    LOG_EXPERIMENTS: process.env.NEXT_PUBLIC_LOG_EXPERIMENTS,
    AUTH0_CLIENT_ID: process.env.AUTH0_CLIENT_ID,
    AUTH0_CLIENT_SECRET: process.env.AUTH0_CLIENT_SECRET,
    AUTH0_ISSUER_BASE_URL: process.env.AUTH0_ISSUER_BASE_URL,
    AUTH0_AUDIENCE: process.env.AUTH0_AUDIENCE,
    LOKI_HOST: process.env.LOKI_HOST,
    WEGLOT_API_KEY: process.env.NEXT_PUBLIC_WEGLOT_API_KEY,
    GA_MEASUREMENT_ID: process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID,
    NEXT_PUBLIC_GOOGLE_MAPS_API_KEY:
        process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY,
    GEO_IP_LICENSE_KEY: process.env.GEO_IP_LICENSE_KEY,
    GEO_IP_ACCOUNT_ID: process.env.GEO_IP_ACCOUNT_ID,
    CMS_TOKEN: process.env.CMS_TOKEN,
    MACHINE_SEARCH_URL: process.env.NEXT_PUBLIC_MACHINE_SEARCH_URL,
    MACHINE_MEDIA_ORIGINAL_CDN_URL: process.env.MACHINE_MEDIA_ORIGINAL_CDN_URL,
    AUTH0_MACHINE_SEARCH_AUDIENCE: process.env.AUTH0_MACHINE_SEARCH_AUDIENCE,
    AUTH0_ZOHO_TOOLS_AUDIENCE: process.env.AUTH0_ZOHO_TOOLS_AUDIENCE,
    TOHAN_TOKEN_DIR: process.env.TOHAN_TOKEN_DIR ?? '.',
    OWN_URL: process.env.NEXT_PUBLIC_OWN_URL,
    RABBITMQ_CONNECTION_URI: process.env.RABBITMQ_CONNECTION_URI?.split(','),
    WEBSITE_ASSETS_CDN_URL: process.env.NEXT_PUBLIC_WEBSITE_ASSETS_CDN_URL,
    WEBSITE_ASSETS_CDN_URL_IMAGEKIT:
        process.env.NEXT_PUBLIC_WEBSITE_ASSETS_CDN_URL_IMAGEKIT,
    STADIAMAPS_API_KEY: process.env.STADIAMAPS_API_KEY,
    ZOHO_TOOLS_FILE_CDN_URL: process.env.NEXT_PUBLIC_ZOHO_TOOLS_FILE_CDN_URL,
    ZOHO_TOOLS_BACKEND_URL: process.env.ZOHO_TOOLS_BACKEND_URL,
};
